import React from 'react'
import { Button } from '@/components/ui/button'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { Select } from 'antd'
import { BonusCampaignsDto } from 'api/Wallet/Types/MarketingBonusCampaignDto'
import { isEmpty, isNotEmpty } from 'utils/is-empty'

export type SelectBonusCampaignModalOpenEvent = { filterId?: string; value: boolean }

interface ExtendedFilterDescriptor extends FilterDescriptor {
  id?: string
}

interface SelectBonusCampaignFilterProps {
  filter: ExtendedFilterDescriptor
  onFilterChange: (event: { nextFilter: ExtendedFilterDescriptor }) => void
  onCampaignModalOpen?: (event: SelectBonusCampaignModalOpenEvent) => void
}

export const SelectBonusCampaignFilter: React.FC<SelectBonusCampaignFilterProps> = (props) => {
  const { filter, onFilterChange, onCampaignModalOpen } = props

  const campaignsSelected = filter?.value ?? []
  const selectValues = filter?.value?.map((campaign: BonusCampaignsDto) => campaign.id) ?? []

  if ((isEmpty(selectValues) || filter?.value === null) && onCampaignModalOpen) {
    return (
      <Button
        variant='outline'
        size='sm'
        onClick={() => {
          onCampaignModalOpen({ filterId: filter.id, value: true })
        }}
      >
        Choose Campaigns
      </Button>
    )
  }

  return (
    <Select
      placeholder='Campaigns'
      mode='multiple'
      value={selectValues}
      open={false}
      onFocus={() => {
        if (onCampaignModalOpen) {
          onCampaignModalOpen({ filterId: filter.id, value: true })
        }
      }}
      onChange={(values: string[]) => {
        const campaignsState = isNotEmpty(values)
          ? campaignsSelected.filter((x: BonusCampaignsDto) => values.includes(x.id))
          : []

        onFilterChange({
          nextFilter: { ...filter, value: campaignsState },
        })
      }}
      style={{ width: '250px' }}
    >
      {campaignsSelected.map((campaign: BonusCampaignsDto) => (
        <Select.Option value={campaign.id} key={campaign.id}>
          {campaign.name}
        </Select.Option>
      ))}
    </Select>
  )
}
